module.exports = __webpack_public_path__ + "apple-icon-57x57.png?3fad71e79cf4c78c7cdfb580a44f86e7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-57x57.png
// module id = 132
// module chunks = 0